import { c as _c } from "react/compiler-runtime";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
export const LeftArrow = t0 => {
  const $ = _c(2);
  const {
    onClick
  } = t0;
  let t1;
  if ($[0] !== onClick) {
    t1 = <KeyboardArrowLeftIcon aria-label="KeyboardArrowLeft" onClick={onClick} />;
    $[0] = onClick;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};